import { LitElement, html } from 'lit';
import { registerComponent } from '../common/definitions/register.js';
import { styles } from './themes/rating-symbol.base.css.js';
class IgcRatingSymbolComponent extends LitElement {
    static register() {
        registerComponent(IgcRatingSymbolComponent);
    }
    connectedCallback() {
        super.connectedCallback();
        this.slot = this.slot.length > 0 ? this.slot : 'symbol';
    }
    render() {
        return html `
      <div part="symbol full">
        <slot> </slot>
      </div>
      <div part="symbol empty">
        <slot name="empty"></slot>
      </div>
    `;
    }
}
IgcRatingSymbolComponent.tagName = 'igc-rating-symbol';
IgcRatingSymbolComponent.styles = [styles];
export default IgcRatingSymbolComponent;
